export default __webpack_public_path__ + "static/media/8.a2ea70e7.png";